import React, { memo } from 'react';

const SimpleMobileTicketGrid = memo(({ 
  tickets, 
  onTicketClick, 
  selectedTickets = [], 
  isMultiSelectMode = false 
}) => {
  const handleTicketClick = (ticket) => {
    if (!ticket.sold && !ticket.reserved) {
      onTicketClick(ticket);
    }
  };

  const getTicketClass = (ticket) => {
    const isSelected = selectedTickets.some(t => t.id === ticket.id);
    
    if (ticket.sold) {
      return 'bg-red-500 text-white opacity-60 cursor-not-allowed';
    }
    if (ticket.reserved) {
      return 'bg-yellow-400 text-gray-800 border-2 border-yellow-500 cursor-not-allowed';
    }
    if (isSelected) {
      return 'bg-purple-500 text-white ring-2 ring-purple-300 transform scale-105';
    }
    return 'bg-white border-2 border-gray-200 hover:bg-purple-50 active:bg-purple-100';
  };

  return (
    <div className="p-3 bg-gray-50 h-full overflow-y-auto">
      <div className="grid grid-cols-5 gap-2 pb-20">
        {tickets.map((ticket) => (
          <button
            key={ticket.id}
            onClick={() => handleTicketClick(ticket)}
            disabled={ticket.sold || ticket.reserved}
            className={`
              relative rounded-lg font-bold text-sm
              transition-all duration-200 transform active:scale-95
              flex items-center justify-center
              ${ticket.displayNumbers && ticket.displayNumbers.includes('-') 
                ? 'min-h-[80px]' // Altura mínima para múltiples números en móvil
                : 'aspect-square'} // Mantener cuadrado para números únicos
              ${getTicketClass(ticket)}
            `}
          >
            {/* Renderizar números con soporte para múltiples oportunidades */}
            {(() => {
              const numbers = ticket.displayNumbers || ticket.number.toString();
              const hasMultipleNumbers = numbers.toString().includes('-');
              
              if (hasMultipleNumbers) {
                // Dividir los números y mostrarlos en líneas separadas
                const numberArray = numbers.toString().split('-');
                return (
                  <div className="flex flex-col items-center justify-center space-y-0 py-1">
                    {numberArray.map((num, index) => (
                      <span key={index} className="text-xs font-bold leading-none block">
                        {num.trim()}
                      </span>
                    ))}
                  </div>
                );
              } else {
                // Mostrar número único normalmente
                return (
                  <span className="text-base">
                    {numbers}
                  </span>
                );
              }
            })()}
            
            {/* Indicador de reservado */}
            {ticket.reserved && !ticket.sold && (
              <span className="absolute top-1 right-1 text-xs font-bold">!</span>
            )}
            
            {/* Check de seleccionado */}
            {selectedTickets.some(t => t.id === ticket.id) && (
              <svg className="absolute top-1 right-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
});

SimpleMobileTicketGrid.displayName = 'SimpleMobileTicketGrid';

export default SimpleMobileTicketGrid;